<div class="admin-login-container">
  <div class="admin-login-card">
    <div class="login-header">
      <div class="logo-section">
        <img src="./mobileLogo.png" alt="Height Gain" class="logo">
        <h1>Admin Panel</h1>
        <!-- <p class="subtitle">Admin Panel</p> -->
      </div>
    </div>

    <div class="login-form">
      <h2>Admin Login</h2>
      <p class="login-description">Enter your credentials to access the admin panel</p>

      <form (ngSubmit)="onLogin()" #loginForm="ngForm">
        <div class="form-group">
          <label for="email">Email Address</label>
          <div class="input-wrapper">
            <i class="fas fa-envelope input-icon"></i>
            <input
              type="email"
              id="email"
              name="email"
              [(ngModel)]="loginData.email"
              placeholder="Enter your email"
              required
              class="form-input"
              [class.error]="loginForm.submitted && !loginData.email"
            >
          </div>
          @if (loginForm.submitted && !loginData.email) {
          <div class="error-message">
            Email is required
          </div>
          }
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-wrapper">
            <i class="fas fa-lock input-icon"></i>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              [(ngModel)]="loginData.password"
              placeholder="Enter your password"
              required
              class="form-input"
              [class.error]="loginForm.submitted && !loginData.password"
            >
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          @if (loginForm.submitted && !loginData.password) {
          <div class="error-message">
            Password is required
          </div>
          }
        </div>

        <button
          type="submit"
          class="login-btn"
          [disabled]="isLoading"
          [class.loading]="isLoading"
        >
          @if (!isLoading) {
          <span>
            <i class="fas fa-sign-in-alt"></i>
            Sign In
          </span>
          } @else {
          <span>
            <i class="fas fa-spinner fa-spin"></i>
            Signing In...
          </span>
          }
        </button>
      </form>

      <div class="login-footer">
        <p class="user-login-link">
          Are you a customer? 
          <a (click)="goToUserLogin()" class="link">Sign in here</a>
        </p>
      </div>
    </div>
  </div>
</div> 